export const getToken = () => {
  const userToken = localStorage.getItem("userToken");
  return userToken;
};

export const getUserType = () => {
  const userType = localStorage.getItem('userType');
  return userType;
};

export const getType = () => {
  const type = localStorage.getItem('type');
  return type;
};

export const getAccessToken = () => {
  const accessToken = localStorage.getItem('accessToken');
  return accessToken;
};

export const getLoginSource = () => {
  const loginSource = localStorage.getItem('loginSource');
  return loginSource;
};
